import { Injectable } from '@angular/core';

import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, tap } from "rxjs/operators";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AddVehiclesService } from '../app/add-vehicles/add-vehicles.service'
import { environment } from 'src/environments/environment';
@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService , private addVehicleService : AddVehiclesService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    const token  = sessionStorage.getItem('token');
   

    console.log(req.url)
    if( req.url ==  environment.filePath){
        if (token) {
            // console.log(token)
            req = req.clone({ headers: req.headers.set('x-access-token', token) });
        }

        let handleRequest: Observable<HttpEvent<any>> = next.handle(req);
    
        return handleRequest.pipe(
            tap((success: any) => {
                setTimeout(() => {
    
                    // this.spinner.hide();
                }, 3000);
    
    
            }),
            catchError((err: any) => {
                if (err.status == 401) {
    
                    sessionStorage.clear();
                    this.router.navigateByUrl('/pages/login-boxed');
                    this.toastr.error('Please Sign In.');
                    this.spinner.hide()
    
                }
    
                else if (err.status == 500) {
                    // console.log('Some server error has occured. Please try again later.');
                    // document.getElementById('spinner').style.display = 'none';
                    // this.errorService.addErrors([{'error':'Some server error has occured. Please try again later.','status':'500'}]);
                }
                setTimeout(() => {
    
                    // this.spinner.hide();
                }, 3000);
    
                return observableThrowError(err);
    
            })
        );
    }else{

         // let currentUser = JSON.parse(value);
    if (token) {
        // console.log(token)
        req = req.clone({ headers: req.headers.set('x-access-token', token) });
    }

        if (!req.headers.has('Content-Type')) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        }
    
        req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
    
    
        let handleRequest: Observable<HttpEvent<any>> = next.handle(req);
    
        return handleRequest.pipe(
            tap((success: any) => {
                setTimeout(() => {
    
                    // this.spinner.hide();
                }, 3000);
    
    
            }),
            catchError((err: any) => {
                if (err.status == 401) {
    
                    sessionStorage.clear();
                    this.router.navigateByUrl('/pages/login-boxed');
                    this.toastr.error('Please Sign In.');
                    this.spinner.hide()
    
                }
    
                else if (err.status == 500) {
                    // console.log('Some server error has occured. Please try again later.');
                    // document.getElementById('spinner').style.display = 'none';
                    // this.errorService.addErrors([{'error':'Some server error has occured. Please try again later.','status':'500'}]);
                }
                setTimeout(() => {
    
                    // this.spinner.hide();
                }, 3000);
    
                return observableThrowError(err);
    
            })
        );
    }

  


}
}
